import type { OrgUser } from '../../api/types/OrgUser';

export enum OpenFgaRoles {
  RaptorAdmin = 'raptoradmin',
  SentryDeviceAdmin = 'sentry_device_admin',
  SentryEdgeNodeProvisioner = 'sentry_edge_node_provisioner',
}

export const OPEN_FGA_ROLE_TO_ORG_USER: Record<OpenFgaRoles, keyof OrgUser> = {
  [OpenFgaRoles.RaptorAdmin]: 'raptoradmin',
  [OpenFgaRoles.SentryDeviceAdmin]: 'sentryDeviceAdmin',
  [OpenFgaRoles.SentryEdgeNodeProvisioner]: 'sentryEdgeNodeProvisioner',
};
